<template>
  <div class="h-dialogContainer">
    <!--<div class="h100vh-116">-->
      <GroupMemberTableMenu @methodEnum='methodEnum'></GroupMemberTableMenu>
    <!--</div>-->
    <div class="h100vh-435">
      <ejs-grid ref='grid' :dataSource="data" :allowResizing='true' :allowPaging='true' :pageSettings="page" height="calc(100% - 0px)">
        <e-columns>
          <e-column type='checkbox' :headerText="$t('SubscriberIms.userNo')" width='40' textAlign='Center'></e-column>
          <e-column field='impu' :headerText="$t('SubscriberIms.userNo')" width='110' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='memberUserName' :headerText="$t('SubscriberIms.userName')" width='110' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='impugrpclass' :headerText="$t('SubscriberIms.impugrpclass')" width='180' textAlign='Center' clipMode='EllipsisWithTooltip' :formatter="impugrpclassFormat"></e-column>
          <e-column field='impugrppriority' :headerText="$t('SubscriberIms.impugrppriority')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <!--<e-column field='usertype' :headerText="$t('SubscriberIms.rtttype')" width='60' textAlign='Center' clipMode='EllipsisWithTooltip' :formatter="rtttypeFormat"></e-column>-->
          <e-column field='grpproperty' :headerText="$t('SubscriberIms.grpproperty')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip' :formatter="grppropertyFormat"></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref="grpPager" @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
    </div>
    <CustomDialog ref='modGroupMemberPage' :element='dialog.element.eleModImsGroupMember' :styles='dialog.styles' :node="node" >
      <template v-slot:dialog-content>
        <MemberInfoCommon ref='modGroupMember' opCode='mod' :msgid="taskMsgid.modGroupMemberMsgid" :neid="neid" :node="node"></MemberInfoCommon>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import GroupMemberTableMenu from '../GroupMemberTableMenu';
import CustomDialog from '../../../../common/CustomDialog';
import MemberInfoCommon from '../../MemberInfoCommon';
import { EventBus } from '../../../../../plugins/eventBus';

export default {
  name: 'QryGroupMemberDialog',
  components: {
    MemberInfoCommon,
    GroupMemberTableMenu,
    CustomDialog,
    EventBus
  },
  props: [
    'neid',
    'node',
  ],
  data() {
    return {
      data: {},
      userData: [],
      memberInfoData: new Map(),
      grpnum: '',
      taskMsgid: {
        modGroupMemberMsgid: '27829', // 修改隶属关系命令吗
        delGroupMemberMsgid: '27830', // 删除隶属关系命令码
        qryGroupMemberMsgid: '27831', // 查询隶属关系命令吗
      },
      page: {
        pageNo: '1',
        pageSize: '25',
        totalCount: '0',
        pageCount: '0',
      },
      info: {
        msgid: '',
        neid: this.neid,
      },
      vo: {
        flag: '',
        participantType: ''
      },
      dialog: {
        tipInfos: '',
        styles: {
          width: '30%',
          height: '55%',
          visible: false,
          model: true,
          zIndex: 2200
        },
        element: {
          eleModImsGroupMember: {
            target: this.$refs.modGroupMemberPage,
            refName: 'modGroupMember',
            buttonGroup: [
              {
                click: this.closeModImsGroupMemberPage,
                buttonModel: { content: this.$t('SubscriberIms.cancel') }
              },
              {
                click: this.saveModImsGroupMember,
                buttonModel: {
                  content: this.$t('SubscriberIms.confirm'),
                  isPrimary: true
                }
              }
            ],
            title: this.$t('SubscriberIms.controlMember'),
            isClose: true
          },
        }
      },
      logParamInfo: {
        // module: 'subscriber.imsGroup',
        module: 'res.subscriber#res.subscriber_ims#subscriber.imsGroup',
        execFunName: ['subscriber.modGroupMember', 'subscriber.delroupMember']
      },
    };
  },
  methods: {
    async getGridData(grpnum, flag = false, delFlag = false) {
      const $this = this;
      if (flag) {
        await $this.$refs.modGroupMember.initHandler();
      }
      if (grpnum !== undefined) {
        $this.grpnum = grpnum;
      }
      $this.page.pageNo = $this.$refs.grpPager.ej2Instances.currentPage ? $this.$refs.grpPager.ej2Instances.currentPage : 1;
      if (delFlag) {
        $this.page.pageNo = 1;
      }
      const param = {
        vo: { grpnum: $this.grpnum, flag: 1 },
        info: { msgid: this.taskMsgid.qryGroupMemberMsgid, neid: this.neid },
        page: this.page
      };
      $this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', param).then((response) => {
        const res = response.data.resultVal;
        if (res.result === 0) {
          $this.data = res.resultList;
          $this.page.totalCount = res.countrsp;
          // $this.page.pageCount = Math.ceil(res.countrsp / $this.page.pageSize);
        } else {
          if (res.result !== 2418016463) {
            // $this.$layer.alert({ msg: '查询数据错误' });
            EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.qryDataError') });
          } else if (res.result === 2418016463) {
            $this.data = [];
            $this.page.totalCount = 0;
            // $this.page.pageCount = 0;
          }
        }
      });
    },
    methodEnum(opcode) {
      switch (opcode) {
        case 'mod':
          this.openModMemberGroupPage();
          break;
        case 'del':
          this.delMemberinfo();
          break;
        default:
      }
    },
    getCheckedVals(selectOnly = false) {
      // x-> false: 不支持多选   true: 支持多选
      const grpnum = [];
      const checkedData = this.getCheckedData(selectOnly);
      for (let i = 0; i < checkedData.length; i++) {
        grpnum.push(checkedData[i].grpnum);
      }
      return grpnum.length === 0 ? false : grpnum;
    },
    getCheckedData(selectOnly, type) {
      let selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        this.dialog.tipInfos = this.$t('SubscriberIms.noCheckDataTip');
        // this.$layer.alert({ msg: this.dialog.tipInfos });
        EventBus.$emit('toast', { type: 'warning', content: this.dialog.tipInfos });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        this.dialog.tipInfos = this.$t('SubscriberIms.checkDataMoreTip');
        // this.$layer.alert({ msg: this.dialog.tipInfos });
        EventBus.$emit('toast', { type: 'warning', content: this.dialog.tipInfos });
        return false;
      }
      if (selectOnly && selectedRecords.length === 1 && type) {
        this.dialog.tipInfos = this.$t('SubscriberIms.checkDateLessTip');
        // this.$layer.alert({ msg: this.dialog.tipInfos });
        EventBus.$emit('toast', { type: 'warning', content: this.dialog.tipInfos });
        return false;
      }
      if (type && selectOnly) { // 多选 并判断类型
        const tempSelectData = selectedRecords[0][type];
        try {
          selectedRecords.forEach(item => {
            console.log(tempSelectData, item[type]);
            if (item[type] !== tempSelectData) {
              this.dialog.tipInfos = this.$t('SubscriberIms.notModWithDifTypeTip');
              // this.$layer.alert({ msg: this.dialog.tipInfos });
              EventBus.$emit('toast', { type: 'warning', content: this.dialog.tipInfos });
              selectedRecords = [];
              throw new Error('ending');
            }
          });
        } catch (e) { }
      }
      return selectedRecords;
    },

    delMemberinfo() {
      // 判断是否选中数据
      const userList = this.getCheckedData(true, false);
      if (userList) {
        this.$layer.confirm({
          msg: this.$t('SubscriberIms.deleteConfirm'),
          btn1: {
            msg: this.$t('SubscriberIms.cancel')
          },
         btn2: {
            msg: this.$t('SubscriberIms.confirm'),
            func: () => {
              const resultObj = [];
              for (let i = 0; i < userList.length; i++) {
                // resultObj.push({ operObj: '组号码'+ this.grpnum +",用户号"+ userList[i].impu });
                resultObj.push({ operObj: `${this.$t('SubscriberIms.groupNo')}${this.grpnum}，${this.$t('SubscriberIms.userNo')}${userList[i].impu}` }); // 组号：xxx，用户号：xxx
              }
              const logParam = {
                module: this.logParamInfo.module, // IMS群组管理
                execFunName: this.logParamInfo.execFunName[1], // 删除隶属关系
                exectype: 3,
                execData: resultObj,
              };
              const paramMap = {
                vo: { grpcount: 1, grpnums: [this.grpnum], usercount: userList.length, resultList: userList },
                info: { msgid: this.taskMsgid.delGroupMemberMsgid, neid: this.neid },
                log: logParam
              };
              console.log('paramMap=', paramMap, this.neid);
              this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', paramMap).then((response) => {
                // this.$parent.$parent.$parent.$refs.modGroupMemberPage.close();
                this.$parent.$parent.$parent.$refs.dialogListPage.show();
                response.data.resultVal.forEach((item, index) => {
                  resultObj[index].operResult = item.display;
                  resultObj[index].operCode = item.code;
                });
                this.$parent.$parent.$parent.$refs.dialogList.addOperetionResultList(resultObj);
                this.getGridData(this.grpnum, false, true);
              });
            }
          }
        });
      }
    },
    openModMemberGroupPage() {
      // 弹出修改页面
      const groupid = this.getCheckedData(false, false);
      if (groupid) {
        this.$refs.modGroupMemberPage.show();
        this.userData = groupid;
        this.$refs.modGroupMember.mainHandler(groupid, { opCode: 'mod' });
      }
    },
    closeModImsGroupMemberPage() {
      this.$refs.modGroupMemberPage.clear();
      this.$refs.modGroupMemberPage.close();
    },
    // 修改保存
    saveModImsGroupMember() {
      console.log(this.$refs.modGroupMember.$refs.base.getDatas());
      const memInfo = this.$refs.modGroupMember.$refs.base.getDatas();
      console.log('memInfo', memInfo);
      const userList = this.userData;
      const grpnum = [this.grpnum];
      const resultObj = [];
      userList.forEach(item => {
        item.impugrppriority = memInfo.get('impugrppriority');
        item.grpproperty = memInfo.get('grpproperty');
        item.impugrpclass = memInfo.get('impugrpclass');
      });
      let k = 0,
        i = 0,
        j = 0;
      const grplen = grpnum.length;
      const impulen = userList.length;
      for (;i < grplen; i++) {
        for (;j < impulen; j++) {
          // resultObj[k] = { operObj: '组号码'+grpnum[i] +'，用户号'+ userList[j].impu }; // 组号：xxx，用户号：xxx
          resultObj.push({ operObj: `${this.$t('SubscriberIms.groupNo')}${grpnum[i]}，${this.$t('SubscriberIms.userNo')}${userList[i].impu}` }); // 组号：xxx，用户号：xxx
        }
        j = 0;
      }
      const logParam = {
        module: this.logParamInfo.module, // IMS群组管理
        execFunName: this.logParamInfo.execFunName[0], // 修改隶属关系
        exectype: 2,
        execData: resultObj,
      };
      const param = {
        vo: { grpcount: grpnum.length, grpnums: grpnum, usercount: userList.length, resultList: userList },
        info: { neid: this.neid, msgid: this.taskMsgid.modGroupMemberMsgid },
        log: logParam
      };
      this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', param).then((response) => {
        this.$refs.modGroupMemberPage.clear();
        this.$refs.modGroupMemberPage.close();
        if (response.data.errorCode.indexOf('subscriber.') > -1) {
          // this.$layer.alert({ msg: response.data.errorString });
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        } else {
          this.$parent.$parent.$parent.$refs.dialogListPage.show();
          response.data.resultVal.forEach((item, index) => {
            resultObj[index].operResult = item.display;
            resultObj[index].operCode = item.code;
          });
          this.$parent.$parent.$parent.$refs.dialogList.addOperetionResultList(resultObj);
          this.getGridData(this.grpnum, false);
        }
      });
    },
    impugrpclassFormat(grids, data) {
      if (this.memberInfoData.size === 0) {
        this.memberInfoData = this.$refs.modGroupMember.getMemberInfo();
      }
      // 需要做特殊处理
      if (data.impugrpclass === undefined) {
        data.impugrpclass = 7;
      }
      return this.$refs.modGroupMember.impugrpclassShow(data.impugrpclass, this.memberInfoData);
    },
    grppropertyFormat(grids, data) {
      if (this.memberInfoData.size === 0) {
        this.memberInfoData = this.$refs.modGroupMember.getMemberInfo();
      }
      const grpprop = this.memberInfoData.get('grpproperty').valueMap;
      return data.grpproperty === undefined ? '' : grpprop.get(data.grpproperty.toString());
    },
  }
};
</script>

<style scoped>

</style>
